import React from "react";
import { DetachedTaskFilters } from "./DetachedTaskFilters";
import { ProductIncomingTaskFilters } from "./ProductIncomingTaskFilters";
import { BrushCuttingTaskFilters } from "./BrushCuttingTaskFilters";
import { ContourFarmingTaskFilters } from "./ContourFarmingTaskFilters";
import { FertilizationTaskFilters } from "./FertilizationTaskFilters";
import { FencingTaskFilters } from "./FencingTaskFilters";
import { PlantingTaskFilters } from "./PlantingTaskFilters";
import { SoilPreparationTaskFilters } from "./SoilPreparationTaskFilters";
import { SprayingTaskFilters } from "./SprayingTaskFilters";
import { WaterTroughTaskFilters } from "./WaterTroughTaskFilters";
import type {
  DetachedTaskFiltersProps,
  ProductIncomingTaskFiltersProps,
  StandardPastureTaskFiltersProps,
} from "./types";

export type CreateTaskFilterStepProps = {
  task: ITask;
  standardProps: StandardPastureTaskFiltersProps;
  detachedProps: DetachedTaskFiltersProps;
  productIncomingProps: ProductIncomingTaskFiltersProps;
};

/** Registro por `task.type`: um componente por tipo (aliases compartilham o layout pasto). */
export function CreateTaskFilterStep({
  task,
  standardProps,
  detachedProps,
  productIncomingProps,
}: CreateTaskFilterStepProps) {
  switch (task.type) {
    case "DETACHED_TASK":
      return <DetachedTaskFilters {...detachedProps} />;
    case "PRODUCT_INCOMING":
      return <ProductIncomingTaskFilters {...productIncomingProps} />;
    case "FERTILIZATION":
      return <FertilizationTaskFilters {...standardProps} />;
    case "WATER_TROUGH":
      return <WaterTroughTaskFilters {...standardProps} />;
    case "FENCING":
      return <FencingTaskFilters {...standardProps} />;
    case "CONTOUR_FARMING":
      return <ContourFarmingTaskFilters {...standardProps} />;
    case "PLANTING":
      return <PlantingTaskFilters {...standardProps} />;
    case "SOIL_PREPARATION":
      return <SoilPreparationTaskFilters {...standardProps} />;
    case "SPRAYING":
      return <SprayingTaskFilters {...standardProps} />;
    case "BRUSH_CUTTING":
      return <BrushCuttingTaskFilters {...standardProps} />;
  }
}
